var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFastfood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fastfood_black_24dp 2",
    clipPath: "url(#clip0_4091_11859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0502 19.1585H16.4335C17.1335 19.1585 17.7085 18.6252 17.7918 17.9418L19.1668 4.2085H15.0002V0.833496H13.3585V4.2085H9.21683L9.46683 6.1585C10.8918 6.55016 12.2252 7.2585 13.0252 8.04183C14.2252 9.22516 15.0502 10.4502 15.0502 12.4502V19.1585ZM0.833496 18.3252V17.5002H13.3585V18.3252C13.3585 18.7835 12.9835 19.1585 12.5168 19.1585H1.67516C1.2085 19.1585 0.833496 18.7835 0.833496 18.3252ZM13.3585 12.4918C13.3585 5.82516 0.833496 5.82516 0.833496 12.4918H13.3585ZM0.850163 14.1668H13.3502V15.8335H0.850163V14.1668Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4091_11859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastfood);
export default __webpack_public_path__ + "static/media/fastfood.1b164cba9598774d635b8c88e544ba33.svg";
export { ForwardRef as ReactComponent };